import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../store/session";
import OpenModalButton from "./OpenModalButton";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";

function ProfileButton({ user, isMenuOpen, closeMenu }) {
  const dispatch = useDispatch();
  const [showMenu, setShowMenu] = useState(false);
  const ulRef = useRef();
  const buttonRef = useRef();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setShowMenu((prev) => !prev);
  };

  const handleOutsideClick = (e) => {
    if (
      ulRef.current &&
      !ulRef.current.contains(e.target) &&
      !buttonRef.current.contains(e.target)
    ) {
      setShowMenu(false);
    }
  };


  useEffect(() => {
    if (showMenu) {
      document.addEventListener('click', handleOutsideClick);
      return () => document.removeEventListener('click', handleOutsideClick);
    }
  }, [showMenu]);

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logout());
    setShowMenu(false); // Close the dropdown on logout
    if (closeMenu) closeMenu(); // Close the mobile navigation menu
    localStorage.clear();
    navigate("/");
  };

  const handleLinkClick = () => {
    setShowMenu(false); // Close the dropdown
    if (closeMenu) closeMenu(); // Close the mobile navigation menu
  };

  const ulClassName = `border border-slate-300 profile-dropdown absolute mt-2 w-48 bg-white rounded-lg shadow-lg py-2 transition-all duration-200 z-50 
  ${showMenu ? "opacity-100 scale-100 visible" : "opacity-0 scale-95 invisible "}`;

  const dropdownPosition = isMenuOpen
    ? { right: "auto", top: "2rem" }
    : { right: 0, left: "auto", top: "2rem" };

  return (
    <div className="relative inline-block">
      <button
        ref={buttonRef}
        onClick={toggleMenu}
        aria-label="Account menu"
        className="w-10 h-10 rounded-full bg-white flex items-center justify-center overflow-hidden focus:outline-none shadow-[-2px_-2px_5px_rgba(255,255,255,0.95),3px_3px_8px_rgba(0,0,0,0.16)] hover:shadow-[-1px_-1px_3px_rgba(255,255,255,0.95),2px_2px_5px_rgba(0,0,0,0.14)] active:shadow-[inset_2px_2px_4px_rgba(0,0,0,0.14),inset_-2px_-2px_4px_rgba(255,255,255,0.85)] transition-all"
      >
        <img
          src="/images/profile.png"
          alt="profile"
          className="w-7 h-7 object-cover rounded-full"
        />
      </button>
      <ul
        className={ulClassName}
        ref={ulRef}
        style={dropdownPosition}
      >
        {user ? (
          <>
            <li className="px-4 py-2 text-lg text-gray-800 font-semibold">{user.username}</li>
            <li className="px-4 py-2 text-base text-gray-700">{user.email}</li>
            <hr className="border-gray-200 my-2" />
            <li className="px-4 py-2">
              <Link
                to="/settings"
                onClick={handleLinkClick} // Close dropdown on navigation
                className="flex items-center w-full text-left text-sm text-blue-500 hover:bg-blue-100 hover:text-blue-600 focus:outline-none rounded-md py-2 px-3"
              >
                <img src="/images/setting.png" alt="right" className='text-xs w-4 h-4 mr-2' />
                Settings
              </Link>
            </li>
            <hr className="border-gray-200 my-2" />
            <li className="px-4 py-2">
              <button
                onClick={handleLogout}
                className="flex items-center w-full text-left text-sm text-red-500 hover:bg-red-100 hover:text-red-600 focus:outline-none rounded-md py-2 px-3"
              >
                <img src="/images/logout.png" alt="right" className='text-xs w-4 h-4 mr-2' />
                Log Out
              </button>
            </li>
          </>
        ) : (
          <>
            <li className="px-4 py-2 w-full ">
              <div className="hover:bg-blue-500 hover:text-white focus:outline-none rounded-md py-2 px-3 ">
                <OpenModalButton
                  buttonText={
                    <div className="flex items-center space-x-2">
                      <img src="/images/log-in.png" alt="log-in" className="w-5 h-5" />
                      <span>Log In</span>
                    </div>
                  }
                  onButtonClick={() => {
                    setShowMenu(false); // Close dropdown
                    if (closeMenu) closeMenu(); // Close mobile menu if open
                  }}
                  modalComponent={<LoginForm closeMenu={closeMenu} />}
                  className="z-[10000]" // Ensures modal appears above everything
                />

              </div>
            </li>
            <li className="px-4 py-2 w-full">
              <div className="hover:bg-blue-500 hover:text-white focus:outline-none rounded-md py-2 px-3">
                <OpenModalButton
                  buttonText={
                    <div className="flex items-center space-x-2">
                      <img src="/images/sign-up.png" alt="sign-up" className="w-6 h-6" />
                      <span>Sign Up</span>
                    </div>
                  }
                  onButtonClick={() => {
                    setShowMenu(false); // Close dropdown
                    if (closeMenu) closeMenu(); // Close mobile menu if open
                  }}
                  modalComponent={<SignupForm />}
                  className="z-[10000]" // Ensures modal appears above everything
                />

              </div>
            </li>
          </>

        )}
      </ul>
    </div>
  );
}


export default ProfileButton;
